@let status = consentApiStatus();
@let group = consentGroup();

<fcom-modal
  [open]="modalOpen()"
  [buttons]="ModalButtons.CUSTOM"
  [fitToContent]="true"
  [title]="
    status === ConsentApiStatus.NOT_LOADED || status === ConsentApiStatus.LOADED
      ? ('plus.memberMarketingPreferences.title' | finLocalization)
      : status === ConsentApiStatus.SAVED
        ? ('plus.memberMarketingPreferences.successTitle' | finLocalization)
        : ('plus.memberMarketingPreferences.errorTitle' | finLocalization)
  "
  [forceRemainOpen]="modalOpen()"
>
  @switch (status) {
    @case (ConsentApiStatus.NOT_LOADED) {
      <fcom-loader />
    }
    @case (ConsentApiStatus.LOADED) {
      @if (group) {
        @if (enableConsentChanges) {
          <form
            [formGroup]="marketingPreferencesForm"
            (ngSubmit)="sendConsents()"
            class="marketing-preferences pr-large-x pr-medium-y text"
          >
            <fieldset>
              <legend class="align-left">
                <div class="font-body-1">
                  <p class="pr-small-b ps-xxsmall-t">
                    {{ 'plus.memberMarketingPreferences.memberNumber' | finLocalization }}:
                    <strong>{{ group.fplusMember }}</strong>
                  </p>
                  <p
                    data-testid="cms-description"
                    [innerHTML]="'plus.memberMarketingPreferences.description' | finLocalization | finSafe: 'html'"
                  ></p>
                </div>
              </legend>

              <h4 class="mr-small-t">{{ 'plus.memberMarketingPreferences.emailTitle' | finLocalization }}</h4>

              @for (consent of emailConsents(); track consent.consentTextId; let last = $last) {
                <fcom-checkbox-input
                  [controlName]="consent.consentTextId"
                  [parentForm]="marketingPreferencesForm"
                  [ngClass]="{
                    block: true,
                    'ms-small-t': true,
                    'ms-small-b': last,
                  }"
                >
                  <span class="content" [innerHTML]="consent.text | finSafe: 'html'"></span>
                </fcom-checkbox-input>
              }

              <h4 class="mr-small-t">{{ 'plus.memberMarketingPreferences.personalizationTitle' | finLocalization }}</h4>
              <p
                [innerHTML]="
                  'plus.memberMarketingPreferences.personalizationDescription' | finLocalization | finSafe: 'html'
                "
              ></p>

              @for (consent of personalizationConsents(); track consent.consentTextId; let last = $last) {
                <fcom-checkbox-input
                  [controlName]="consent.consentTextId"
                  [parentForm]="marketingPreferencesForm"
                  [ngClass]="{
                    block: true,
                    'ms-small-t': true,
                    'ms-small-b': last,
                  }"
                >
                  <span class="content" [innerHTML]="consent.text | finSafe: 'html'"></span>
                </fcom-checkbox-input>
              }
            </fieldset>
            <hr />
            <p
              class="pr-small-y align-left"
              [innerHTML]="'plus.memberMarketingPreferences.disclaimer' | finLocalization | finSafe: 'html'"
            ></p>
          </form>
        } @else {
          <form
            [formGroup]="marketingPreferencesForm"
            (ngSubmit)="sendConsents()"
            class="marketing-preferences pr-large-x pr-medium-y text"
          >
            <fieldset>
              <legend class="align-left">
                <div class="font-body-1">
                  <p class="pr-small-b ps-xxsmall-t">
                    {{ 'plus.memberMarketingPreferences.memberNumber' | finLocalization }}:
                    <strong>{{ group.fplusMember }}</strong>
                  </p>
                  <p
                    data-testid="cms-description"
                    [innerHTML]="'plus.memberMarketingPreferences.description' | finLocalization | finSafe: 'html'"
                  ></p>
                </div>
              </legend>

              @for (consent of group.consents; track consent.consentTextId; let last = $last) {
                <fcom-checkbox-input
                  [controlName]="consent.consentTextId"
                  [parentForm]="marketingPreferencesForm"
                  [ngClass]="{
                    block: true,
                    'ms-small-t': true,
                    'ms-small-b': last,
                  }"
                >
                  <span class="content" [innerHTML]="consent.text | finSafe: 'html'"></span>
                </fcom-checkbox-input>
              }
            </fieldset>
            <hr />
            <p
              class="pr-small-y align-left"
              [innerHTML]="'plus.memberMarketingPreferences.disclaimer' | finLocalization | finSafe: 'html'"
            ></p>
          </form>
        }
      }
    }
    @case (ConsentApiStatus.SAVED) {
      <p
        class="pr-large-x pr-small-y"
        [innerHTML]="'plus.memberMarketingPreferences.success' | finLocalization | finSafe: 'html'"
      ></p>
    }
    @case (ConsentApiStatus.ERROR) {
      <p
        class="pr-large-x pr-small-y"
        [innerHTML]="'plus.memberMarketingPreferences.error' | finLocalization | finSafe: 'html'"
      ></p>
    }
  }

  <div buttons>
    @switch (status) {
      @case (ConsentApiStatus.LOADED) {
        <fcom-button
          class="pr-xxsmall-l"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [text]="'plus.memberMarketingPreferences.saveButtonTitle' | finLocalization"
          [disabled]="!marketingPreferencesForm?.valid"
          data-testid="save-button"
          (clickBtn)="sendConsents()"
        />
      }
      @case (ConsentApiStatus.SAVED) {
        @let url = successButtonUrl();
        @if (url) {
          <fcom-button
            [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
            [text]="'plus.memberMarketingPreferences.successButtonTitle' | finLocalization"
            data-testid="success-button"
            (clickBtn)="onClick(url)"
          />
        }
      }
      @case (ConsentApiStatus.ERROR) {
        @let url = errorButtonUrl();
        @if (url) {
          <fcom-button
            [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
            [text]="'plus.memberMarketingPreferences.errorButtonTitle' | finLocalization"
            data-testid="error-button"
            (clickBtn)="onClick(url)"
          />
        }
      }
    }
  </div>
</fcom-modal>
